// Define API base URL
export const API_URL = process.env.REACT_APP_BASE_URL;
